import React from 'react';
import PropTypes from 'prop-types';
import {getDimensions, SIZE} from '../../utils/IntegrationIconSizer';
import {FixedColorsIcon} from '../FixedColorsIcon';

export const QuickbooksIcon = ({size, onClick}) => {
	const dimensions = getDimensions(size);

	const handleClick = e => {
		e.stopPropagation();
		onClick(e);
	};
	const optionalHandleClick = onClick ? handleClick : undefined;

	return (
		<FixedColorsIcon onClick={optionalHandleClick} width={dimensions} height={dimensions}>
			<svg viewBox="0 0 41 41" version="1.1" xmlns="http://www.w3.org/2000/svg" width={dimensions} height={dimensions}>
				<path
					d="M40.97,20.84 C40.97,31.89 32.02,40.84 20.97,40.84 C9.92,40.84 0.97,31.89 0.97,20.84 C0.97,9.79 9.92,0.84 20.97,0.84 C32.02,0.84 40.97,9.79 40.97,20.84 Z"
					id="Fill-1-3-2"
					fill="#2CA01C"
				></path>
				<path
					d="M27.6,13.06 L26.49,13.06 L26.49,16 L27.6,16 C30.3,16 32.49,18.19 32.49,20.89 C32.49,23.59 30.3,25.78 27.6,25.78 L24.89,25.78 L24.89,10.62 C24.89,9.02 23.6,7.73 22,7.73 L22,7.73 L22,7.73 L22,28.62 L27.59,28.62 C31.89,28.62 35.37,25.13 35.37,20.84 C35.37,16.55 31.89,13.07 27.59,13.06 L27.59,13.06 L27.6,13.06 L27.6,13.06 Z M14.26,28.62 L15.46,28.62 L15.46,25.73 L14.26,25.73 C11.56,25.73 9.37,23.54 9.37,20.84 C9.37,18.14 11.56,15.95 14.26,15.95 L16.97,15.95 L16.97,31.06 C16.97,32.66 18.26,33.95 19.86,33.95 L19.86,33.95 L19.86,33.95 L19.86,13.06 L14.27,13.06 C9.97,13.06 6.49,16.55 6.49,20.84 C6.49,25.13 9.97,28.61 14.27,28.62 L14.27,28.62 L14.26,28.62 Z"
					id="Fill-4-2"
					fill="#FFFFFF"
				></path>
			</svg>
		</FixedColorsIcon>
	);
};

QuickbooksIcon.SIZE = SIZE;
QuickbooksIcon.propTypes = {
	onClick: PropTypes.func,
	size: PropTypes.oneOf(Object.values(SIZE)),
};
